import React from 'react';
import { Card } from 'react-bootstrap';
import '../../assets/css/vendors/HotelComponents/hotelStatCard.css';

const HotelStatCard = ({ 
  title, 
  value, 
  icon, 
  badgeText,
  cardClass = '',
  iconBg = 'hsc-bg-gradient-primary',
  iconColor = 'text-white'
}) => {
  return (
    <Card className={`hsc-stat-card ${cardClass}`}>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h6 className="hsc-card-title text-muted mb-2">{title}</h6> {/* Updated */}
            <h3 className="fw-bold mb-3">Rs. {value.toLocaleString('en-IN')}</h3>
            {badgeText && (
              <span className="badge bg-success bg-opacity-10 text-success p-2">
                {badgeText}
              </span>
            )}
          </div>
          <div className={`rounded-circle p-3 ${iconBg} ${iconColor}`}>
            <span className="hsc-stat-icon">{icon}</span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default HotelStatCard;